import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AdminPremium.css'; // Crée un petit fichier CSS pour styliser ton tableau

function AdminPremium() {
  const [demandes, setDemandes] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔑 Fonction pour récupérer le token et préparer l'en-tête (Header) de la requête
  const getConfig = () => {
    const token = localStorage.getItem('token');
    return {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };
  };

  // Fonction pour charger les données au démarrage
  const fetchDemandes = async () => {
    try {
      const res = await axios.get("https://api.memofacdz.com/api/premium/requests", getConfig());
      setDemandes(res.data);
    } catch (error) {
      console.error("Erreur de chargement", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDemandes();
  }, []);

  // Fonction pour approuver
  const handleApprove = async (id) => {
    if (!window.confirm("Confirmer l'activation de ce compte Premium ?")) return;
    
    try {
      await axios.put(`https://api.memofacdz.com/api/premium/approve/${id}`, {}, getConfig());
      alert("Compte approuvé !");
      fetchDemandes(); // On recharge la liste pour mettre à jour l'affichage
    } catch (error) {
      alert("Erreur lors de l'approbation.");
    }
  };

  // Fonction pour refuser
  const handleReject = async (id) => {
    if (!window.confirm("Voulez-vous vraiment refuser cette demande ?")) return;

    try {
      await axios.put(`https://api.memofacdz.com/api/premium/reject/${id}`, {}, getConfig());
      alert("Demande refusée.");
      fetchDemandes(); // On recharge la liste
    } catch (error) {
      alert("Erreur lors du refus.");
    }
  };

  // Fonction pour ouvrir le reçu dans un nouvel onglet
  const openReceipt = (imagePath) => {
    // On remplace les antislashs potentiels (Windows) par des slashs classiques
    const cleanPath = imagePath.replace(/\\/g, '/');
    window.open(`https://api.memofacdz.com/${cleanPath}`, '_blank');
  };

  if (loading) return <div>Chargement des demandes...</div>;

  return (
    <div className="admin-premium-container" style={{ padding: '50px' }}>
      <h2 style={{ marginTop: '20px' }}>Gestion des demandes Premium</h2>
      
      <table className="admin-table" style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
        <thead>
          <tr style={{ backgroundColor: '#f4f4f4', textAlign: 'left' }}>
            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Date</th>
            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Utilisateur</th>
            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Nom / Prénom</th>
            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Reçu</th>
            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Statut</th>
            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {demandes.map((demande) => (
            <tr key={demande._id}>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                {new Date(demande.createdAt).toLocaleDateString()}
              </td>
              <td style={{ padding: '10px', border: '1px solid #ddd', fontWeight: 'bold' }}>
                {demande.username}
              </td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                {demande.nom} {demande.prenom}
              </td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                <button 
                  onClick={() => openReceipt(demande.imagePath)}
                  style={{ cursor: 'pointer', padding: '5px 10px', background: '#007bff', color: 'white', border: 'none', borderRadius: '4px' }}
                >
                  👁️ Voir le reçu
                </button>
              </td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>
  {/* Badge sécurisé */}
  {demande.statut ? (
    <span style={{
      padding: '5px 10px', 
      borderRadius: '15px', 
      color: '#fff', 
      fontSize: '12px',
      fontWeight: 'bold',
      backgroundColor: 
        demande.statut.toLowerCase() === 'oui' ? '#28a745' :  // Vert
        demande.statut.toLowerCase() === 'non' ? '#dc3545' : '#ffc107' // Rouge si 'non', Jaune sinon
    }}>
      {demande.statut.toUpperCase()}
    </span>
  ) : (
    /* Cas de sécurité si une ligne n'a pas encore de statut en BDD */
    <span style={{ padding: '5px 10px', borderRadius: '15px', color: '#fff', fontSize: '12px', fontWeight: 'bold', backgroundColor: '#ffc107' }}>
      EN ATTENTE
    </span>
  )}
</td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                {demande.statut === 'en_attente' && (
                  <>
                    <button onClick={() => handleApprove(demande._id)} style={{ marginRight: '10px', background: '#28a745', color: 'white', border: 'none', padding: '5px 10px', cursor: 'pointer', borderRadius: '4px' }}>
                      ✅ Accepter
                    </button>
                    <button onClick={() => handleReject(demande._id)} style={{ background: '#dc3545', color: 'white', border: 'none', padding: '5px 10px', cursor: 'pointer', borderRadius: '4px' }}>
                      ❌ Refuser
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
          
          {demandes.length === 0 && (
            <tr>
              <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>Aucune demande pour le moment.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default AdminPremium;